import React, { Component } from 'react';

import { CapacitorContext } from './context';

class CapacitorConsumer extends Component {
  render() {
    return (
      <CapacitorContext.Consumer>
        {(context) => this.props.children(context)}
      </CapacitorContext.Consumer>
    );
  }
}

export default CapacitorConsumer;
